import { lazy } from "react";

export const OpportunitiesPage = lazy(() =>
  import("./ui/opportunities").then((module) => ({
    default: module.Opportunities,
  }))
);
